import { NgClass, NgStyle } from '@angular/common';
import { afterNextRender, ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';

import { Dynamic } from '@shared/registry/dynamic';

import { type InfoListCardConfig } from './info-list-card.types';

@Component({
  selector: 'app-info-list-card',
  templateUrl: './info-list-card.html',
  imports: [Dynamic, NgClass, NgStyle],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoListCard {
  readonly config = input.required<InfoListCardConfig>();

  private readonly gradientStyle = signal<Record<string, string>>({});

  protected readonly backgroundStyle = computed(() => {
    if (this.config().showBackgroundGradient === false) {
      return { background: 'var(--infolistcard-background)' };
    }
    return this.gradientStyle();
  });

  constructor() {
    afterNextRender(() => {
      const gradient = getComputedStyle(document.documentElement)
        .getPropertyValue('--infolistcard-background-gradient')
        .trim();

      this.gradientStyle.set({
        background: `linear-gradient(180deg, var(--gradients-${gradient}-start), var(--gradients-${gradient}-middle), var(--gradients-${gradient}-stop))`,
      });
    });
  }
}
